import { render, staticRenderFns } from "./ColorParameterType.vue?vue&type=template&id=d22cb696&scoped=true"
import script from "./ColorParameterType.vue?vue&type=script&lang=js"
export * from "./ColorParameterType.vue?vue&type=script&lang=js"
import style0 from "./ColorParameterType.vue?vue&type=style&index=0&id=d22cb696&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d22cb696",
  null
  
)

export default component.exports